function collapseCollectionDescription() {
  const description = document.querySelector('.collection__description .rte');
  if (!description || description.querySelector('.collection-description__toggle')) return;

  const blocks = Array.from(description.children);
  let paragraphCount = 0;
  let cutIndex = -1;

  for (let i = 0; i < blocks.length; i++) {
    if (blocks[i].tagName === 'P') paragraphCount++;
    if (paragraphCount === 2) { cutIndex = i; break; }
  }
  if (cutIndex === -1 || cutIndex === blocks.length - 1) return;

  // Hide everything after the 2nd paragraph: headings, lists, paragraphs
  const hidden = blocks.slice(cutIndex + 1);
  hidden.forEach(function (el) { el.style.display = 'none'; });

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = 'Read more';
  btn.className = 'collection-description__toggle';
  btn.setAttribute('aria-expanded', 'false');
  description.appendChild(btn);

  btn.addEventListener('click', function () {
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    hidden.forEach(function (el) { el.style.display = isOpen ? 'none' : ''; });
    btn.setAttribute('aria-expanded', String(!isOpen));
    btn.textContent = isOpen ? 'Read more' : 'Read less';
  });
}

document.addEventListener('DOMContentLoaded', collapseCollectionDescription);

// The theme swaps in a fresh, fully expanded description whenever filters, sorting or
// pagination reload the product grid, so collapse it again after each reload.
document.addEventListener('theme:loading:end', collapseCollectionDescription);
